const FONTS = {
  sans: "'sofia-pro', sans-serif",
};

export default FONTS;
